import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {Dialogs} from '../dialogs.js';

import {toastConfig} from './toast.factory';

import PALETTE_SCHEMA from './toast.palette-schema.yaml';

class ToastFeature extends AbstractVisualFeature {
    get name() {
        return 'Toast';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return toastConfig(PALETTE);
    }
}

new ToastFeature(Dialogs);
